import React, { Component, useState } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import {
  Field,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup
} from '@availity/form';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import AddFile from '../../Common/components/AddFile';
import withNavigate from '../../Common/components/withNavigate';

@observer
class DocumentationComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      // Navigation back
      redirectToSignature: false,

      // Navigation to Next
      redirectToReviewSubmit: false,

      selectedRiskCheckbox: [],
      toggleModal: false,
      errorMessages: {},
      redirectToLandingPage: false,
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingstore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentWillMount() {
    if (housingstore.getSupportiveHousingRouteStatus('/signature') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToLandingPage: true });
    } else if (
      housingstore.getSupportiveHousingRouteStatus('/documentation') !== 'completed' &&
      housingstore.getSupportiveHousingRouteStatus('/documentation') !== 'active'
    ) {
      housingstore.setSupportiveHousingPageStatus('#documentation', 'active');
      housingstore.setSupportiveHousingRouteStatus('/documentation', 'active');
    }
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.navigate(1);
    }
  }

  setDocumentation = value => {
    housingstore.setDocumentCategories(value);
    this.syncAttachments(value);
  }

  setRiskFactorsDocuments = value => {
    housingstore.setRiskFactorsDocuments(value);
    this.syncAttachments(value);
  }

  syncAttachments = value => {
    for (let i = 0; i < housingstore.attachments.length; i++) {
      const attachment = housingstore.attachments[i];
      if (!value.includes(attachment.option)) {
        const docIndex = housingstore.attachments.findIndex(attac => attac.option === attachment.option);
        housingstore.attachments = housingstore.attachments.slice(0, docIndex).concat(housingstore.attachments.slice(docIndex + 1));
      }
    }
  }

  setSupplementDocumentation = value => {
    housingstore.setSuppDocRadio(value);
  }

  setDocumentationNotes = event => {
    const { value } = event.target;
    housingstore.setDocumentNotes(value);
  }

  goBack = () => {
    housingstore.setSupportiveHousingPageStatus('#signature', 'active');
    housingstore.setSupportiveHousingRouteStatus('/signature', 'active');
    housingstore.setSupportiveHousingPageStatus('#documentation', 'disabled');
    housingstore.setSupportiveHousingRouteStatus('/documentation', 'inactive');
    this.setState({ redirectToSignature: true });
  }

  submit = (pendingRoute = '/reviewsubmit') => {
    housingstore.setSupportiveHousingPageStatus('#documentation', 'active');
    housingstore.setSupportiveHousingRouteStatus('/documentation', 'completed');
    if (pendingRoute === '/reviewsubmit') {
      this.setState({ redirectToReviewSubmit: true });
      return;
    }
    this.props.navigate(pendingRoute);
  }

  toggle = () => {
    // this.setState({ toggleModal: !this.state.toggleModal });
    if (this.state.toggleModal) {
      this.setState({ toggleModal: false });
    } else {
      this.setState({ toggleModal: true });
    }
  }

  getAttachment = (docName) => {
    let fileName;
    const attac = housingstore.attachments.find(attac => attac.documentName === docName);
    if (attac !== undefined) {
      fileName = attac.fileName;
    }else{
      fileName = undefined;
    }
    return fileName;
  }

  setErrorMessages = (errorMessage, forDelete = false) => {
    this.setState((prevState) => {
      let errorMessages = { ...prevState.errorMessages };
      if (forDelete) {
        delete errorMessages[errorMessage];
      } else {
        errorMessages = { ...errorMessages, ...errorMessage };
      }
      return { errorMessages };
    });
  }


  render() {

    const { redirectToSignature, redirectToReviewSubmit, toggleModal, redirectToLandingPage } = this.state;

    const {
      documentCategories,
      documentNotes,
      supportiveHousingPagesAHAH,
      supportiveHousingPagesNoAHAH,
      memberInfo,
      riskFactorsDocuments
    } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;


    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if (redirectToSignature) {
      return <Navigate to="/signature" />
    }

    if (redirectToReviewSubmit) {
      return <Navigate to="/reviewsubmit" />
    }

    if (redirectToLandingPage) {
      return <Navigate to="/" />;
    }

    return (
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm
            pages={supportiveHousingPages}
            enableReinitialize
            initialValues={{
              docCheck: documentCategories.map(x => x),
              Mental_health_diagnosis_value: this.getAttachment('Mental health diagnosis') || "",
              Substance_use_disorder_value: housingstore.getAttachment("Substance use disorder") || "",
              Comprehensive_Assessment_and_Reporting_Evaluation_value: housingstore.getAttachment("Comprehensive Assessment and Reporting Evaluation") || "",
              A_coordinated_entry_assessment_value: housingstore.getAttachment("A coordinated entry assessment") || "",
              Other_value: housingstore.getAttachment("Other - Health Needs") || "",
              Chronic_Homelessness_value: housingstore.getAttachment("Chronic Homelessness") || "",
              Institutional_Contacts_value: housingstore.getAttachment("Institutional Contacts") || "",
              Residential_Care_Stays_value: housingstore.getAttachment("Residential Care Stays") || "",
              Paid_Caregivers_value: housingstore.getAttachment("Paid Caregivers") || "",
              Other_Risk_Factor_Doc_value: housingstore.getAttachment("Other - Risk Factor") || ""
            }}
            validationSchema={yup.object().shape({
              docCheck: yup.array(),
              Mental_health_diagnosis_value: yup.string().when('docCheck', {
                is: (value) => value.includes('opt1'),
                then: yup.string().required(this.state.errorMessages.Mental_health_diagnosis_value ? this.state.errorMessages.Mental_health_diagnosis_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Substance_use_disorder_value: yup.string().when('docCheck', {
                is: (value) => value.includes('opt2'),
                then: yup.string().required(this.state.errorMessages.Substance_use_disorder_value ? this.state.errorMessages.Substance_use_disorder_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Comprehensive_Assessment_and_Reporting_Evaluation_value: yup.string().when('docCheck', {
                is: (value) => value.includes('opt3'),
                then: yup.string().required(this.state.errorMessages.Comprehensive_Assessment_and_Reporting_Evaluation_value ? this.state.errorMessages.Comprehensive_Assessment_and_Reporting_Evaluation_value : 'File is required'),
                otherwise: yup.string(),
              }),
              A_coordinated_entry_assessment_value: yup.string().when('docCheck', {
                is: (value) => value.includes('opt4'),
                then: yup.string().required(this.state.errorMessages.A_coordinated_entry_assessment_value ? this.state.errorMessages.A_coordinated_entry_assessment_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Other_value: yup.string().when('docCheck', {
                is: (value) => value.includes('opt5'),
                then: yup.string().required(this.state.errorMessages.Other_value ? this.state.errorMessages.Other_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Chronic_Homelessness_value: yup.string().when('docCheck', {
                is: (value) => value.includes('1'),
                then: yup.string().required(this.state.errorMessages.Chronic_Homelessness_value ? this.state.errorMessages.Chronic_Homelessness_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Institutional_Contacts_value: yup.string().when('docCheck', {
                is: (value) => value.includes('2'),
                then: yup.string().required(this.state.errorMessages.Institutional_Contacts_value ? this.state.errorMessages.Institutional_Contacts_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Residential_Care_Stays_value: yup.string().when('docCheck', {
                is: (value) => value.includes('3'),
                then: yup.string().required(this.state.errorMessages.Residential_Care_Stays_value ? this.state.errorMessages.Residential_Care_Stays_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Paid_Caregivers_value: yup.string().when('docCheck', {
                is: (value) => value.includes('4'),
                then: yup.string().required(this.state.errorMessages.Paid_Caregivers_value ? this.state.errorMessages.Paid_Caregivers_value : 'File is required'),
                otherwise: yup.string(),
              }),
              Other_Risk_Factor_Doc_value: yup.string().when('docCheck', {
                is: (value) => value.includes('5'),
                then: yup.string().required(this.state.errorMessages.Other_Risk_Factor_Doc_value ? this.state.errorMessages.Other_Risk_Factor_Doc_value : 'File is required'),
                otherwise: yup.string(),
              })
            })}
            onSubmit={this.submit}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer" />
            <h2 className="poppinsH2">
              Supporting Documentation
            </h2>
            <em>
              <small className="label-font">Please fill out to the best of your ability.</small>
            </em>
            <div className="spacer-16"  >

              <small className="label-font">
                Wellpoint attempts to validate FCS health needs and risk factors with the tools we have access to. If we are unable to validate a
                health need or a risk factor supporting documentation should be provided to aid in validating FCS eligibility for a potential enrollee.
                Supporting documentation are not required for enrollment into FCS services.
              </small>
            </div>
            <div className='spacer-16'>
              <small className='label-font'>To expedite processing, please select and upload any supporting documentation listed below.</small>

            </div>
            <div className='spacer-48' />
            <strong>Select document type and upload:</strong>
            <div className="spacer-16" />
            <Label htmlFor="docCheck">
              <h6>To validate a health need:</h6>
            </Label>
            <div className="label-spacer-16" />
            <CheckboxGroup name="docCheck" value={documentCategories} onChange={this.setDocumentation}>
              <Checkbox
                label="Mental health diagnosis as determined by a licensed behavioral health agency."
                name="mentalHealthdiag"
                id="mentalHealthdiag"
                className="label-font mb-23 no-display"
                groupName="docCheck"
                value="opt1"
              />
              {documentCategories.includes("opt1") ?
                <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Mental health diagnosis', attachment: housingstore.getAttachment("Mental health diagnosis"), option: "opt1" }} />

                : ""
              }

              <div className="mt-3" />
              <Checkbox
                label="Substance Use Disorder (SUD) diagnosis as determined by a licensed behavioral health agency."
                name="diagnosedSubstance"
                id="diagnosedSubstance"
                className="label-font mb-23 no-display"
                groupName="docCheck"
                value="opt2"
              />
              {documentCategories.includes("opt2") ?
                <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Substance use disorder', attachment: housingstore.getAttachment("Substance use disorder"), option: "opt2" }} />
                : ""
              }

              <div className="mt-3" />
              <Checkbox
                label="Comprehensive Assessment and Reporting Evaluation (CARE) demonstrating client needs assistance with three or more activities of daily living (ADL) or
                one or more hands-on ADL."
                name="comprehensiveAssess"
                id="comprehensiveAssess"
                className="label-font mb-23 no-display"
                groupName="docCheck"
                value="opt3"
              />
              {documentCategories.includes("opt3") ?
                <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Comprehensive Assessment and Reporting Evaluation', attachment: housingstore.getAttachment("Comprehensive Assessment and Reporting Evaluation"), option: "opt3" }} />
                : ""
              }

              <div className="mt-3" />
              <Checkbox
                label="A coordinated entry assessment validating client is a homeless individual with a disability."
                name="coordinateentry"
                id="coordinateentry"
                className="label-font mb-23 no-display"
                groupName="docCheck"
                value="opt4"
              />
              {documentCategories.includes("opt4") ?
                <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'A coordinated entry assessment', attachment: housingstore.getAttachment("A coordinated entry assessment"), option: "opt4" }} />
                : ""
              }

              <div className="mt-3" />
              <Checkbox
                label="Other"
                name="otheropt"
                id="otheropt"
                className="label-font mb-23 no-display"
                groupName="docCheck"
                value="opt5"
              />
              {documentCategories.includes("opt5") ?
                <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Other - Health Needs', attachment: housingstore.getAttachment("Other - Health Needs"), option: "opt5" }} />
                : ""
              }

              <div className="spacer" />
              <Row>
                <Col>
                  <h6><b>To validate a risk factors:</b></h6>
                  <Checkbox className="label-font mb-5 no-display" customInput name="riskopt1" label="Chronic Homelessness attestation" value="1" groupName="docCheck" />
                  <div className="mt-3" />
                  {
                    documentCategories.includes("1") && <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Chronic Homelessness', attachment: housingstore.getAttachment("Chronic Homelessness"), option: "1" }} />
                  }
                  <div className="mt-3" />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    customInput name="riskopt2"
                    label="Frequent (two or more instances) or lengthy (90 days or more) institutional contacts as determined by a licensed agency such as: nursing facility,
                                  inpatient psychiatric hospital, inpatient medical hospital, Emergency Department visit, correctional program or institution, or foster care facility in the
                                  past 12 months."
                    value="2"
                    groupName="docCheck" />
                  <div className="mt-3" />
                  {
                    documentCategories.includes("2") && <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Institutional Contacts', attachment: housingstore.getAttachment("Institutional Contacts"), option: "2" }} />
                  }
                  <div className="mt-3" />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    customInput name="riskopt3"
                    label="Frequent residential care stays (two or more) in the past 12 months as documented by a residential care facility such as:
                                evaluation and treatment facility, detox center, inpatient substance use treatment facility, or adult residential care, assisted living or adult family home (AFH)."
                    value="3"
                    groupName="docCheck" />
                  <div className="mt-3" />
                  {
                    documentCategories.includes("3") && <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Residential Care Stays', attachment: housingstore.getAttachment("Residential Care Stays"), option: "3" }} />
                  }
                  <div className="mt-3" />
                  <Checkbox
                    className="label-font mb-5 no-display"
                    customInput name="riskopt4"
                    label="Frequent (three or more) turnover of paid caregivers in the past 12 months as documented from a paid caregiver agency, ALTSA care coordinator,
                                or multiple individual paid caregivers."
                    value="4" />
                  <div className="mt-3"
                    groupName="docCheck" />
                  {
                    documentCategories.includes("4") && <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Paid Caregivers', attachment: housingstore.getAttachment("Paid Caregivers"), option: "4" }} />
                  }
                  <div className="mt-3" />
                  <Checkbox className="label-font mb-5 no-display" customInput name="riskopt5" label="Other" value="5" groupName="docCheck" />
                  <div className="mt-3" />
                  {
                    documentCategories.includes("5") && <AddFile setErrorMessage={this.setErrorMessages} propsData={{ documentName: 'Other - Risk Factor', attachment: housingstore.getAttachment("Other - Risk Factor"), option: "5" }} />
                  }
                  <div className="mt-3" />
                </Col>
              </Row>
            </CheckboxGroup>
            <div className="spacer" />
            <Modal isOpen={toggleModal} toggle={this.toggle} size='lg'>
              <ModalHeader toggle={this.toggle}>Other Records to Keep on File</ModalHeader>
              <ModalBody>
                <h5>
                  <b>Documentation for Enrollee’s Treatment Records</b>
                </h5>
                <div className="spacer" />
                <Label>
                  Do not send these documents to the FCS team with an FCS Assessment.
                </Label>
                <div className="spacer" />
                <Label>
                  Examples of documentation you may want to keep in your enrollee’s treatment record include the following:
                </Label>
                <Row className='mt-4'>
                  <Col sm="6">
                    <li>Social Security Card</li>
                    <li>Background check result</li>
                    <li>Proof of Income</li>
                    <li>Documentation of other assets</li>
                  </Col>
                  <Col sm="6">
                    <li>Birth certificate</li>
                    <li>Legal resident status</li>
                    <li>Protective payee</li>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter className='docModalFooterBg'>
                <Button className='btn btn-primary buttonCancle' onClick={this.toggle}>
                  Cancel
                </Button>
                <Button className='btn btn-primary nextBtn' onClick={this.toggle}>
                  Continue
                </Button>
              </ModalFooter>
            </Modal>

            <Row>
              <Col sm="6">
                <Label className="label-font" htmlFor="evictedDatesField">
                  Notes:
                </Label>
                <Field
                  type="textarea"
                  id="docNotesField"
                  name="docNotesField"
                  className='straighten-borders form-control form-group textAreaHeightDetails'
                  onChange={this.setDocumentationNotes}
                  value={documentNotes}
                  row="3"
                  col="200"
                  maxLength={2000}
                  aria-label='Doc Notes'
                />
                <p className="small text-right mb-0 label-font">2000 Character max</p>
              </Col>
            </Row>
            <Row>
              <Button className="btn-link"
                color="primary"
                onClick={this.toggle}
              >
                <i className='icon icon-info-circle' />Other records to keep on file
              </Button>
            </Row>
            <div className="spacer-64" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
              Review and Submit
            </Button>
          </ProgressValidatedForm>
        </div >
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(DocumentationComponent);

DocumentationComponent.propTypes = {
  navigate: PropTypes.func
};